var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "seg-content seg-sbs" }, [
    _vm.tab == "payment"
      ? _c("div", { staticClass: "user-form" }, [
          _vm._v("(loading your payment)")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tab == "payment3"
      ? _c(
          "div",
          { staticClass: "user-form payment-list" },
          [
            _c("h2", [_vm._v("Your order")]),
            _vm._v(" "),
            _c("cart-view"),
            _vm._v(" "),
            _vm._m(0)
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.tab == "payment3"
      ? _c(
          "form",
          {
            ref: "payment3Form",
            staticClass: "user-form login payment-form",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.doSubmitPayment($event)
              }
            }
          },
          [
            _c("div", { staticClass: "uf-row" }, [
              _c("label", [_vm._v("Cardholder Name:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cardName,
                    expression: "cardName"
                  }
                ],
                attrs: { type: "text", required: "" },
                domProps: { value: _vm.cardName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cardName = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "uf-row" }, [
              _c("label", [_vm._v("Address:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userProfile.address,
                    expression: "userProfile.address"
                  }
                ],
                attrs: { type: "text", required: "" },
                domProps: { value: _vm.userProfile.address },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userProfile, "address", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "uf-row" }, [
              _c("label", [_vm._v("City:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userProfile.city,
                    expression: "userProfile.city"
                  }
                ],
                attrs: { type: "text", required: "" },
                domProps: { value: _vm.userProfile.city },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userProfile, "city", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "uf-row" }, [
              _c("label", [_vm._v("Zip/Postal Code:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.userProfile.zipcode,
                    expression: "userProfile.zipcode"
                  }
                ],
                attrs: { type: "text", required: "" },
                domProps: { value: _vm.userProfile.zipcode },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userProfile, "zipcode", $event.target.value)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "uf-row" }, [
              _c("label", [_vm._v("State:")]),
              _vm._v(" "),
              _vm.states[_vm.userProfile.country]
                ? _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.userProfile.state,
                          expression: "userProfile.state"
                        }
                      ],
                      attrs: { type: "text", required: "" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.userProfile,
                            "state",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.states[_vm.userProfile.country], function(
                      state
                    ) {
                      return _c("option", [_vm._v(_vm._s(state))])
                    }),
                    0
                  )
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.userProfile.state,
                        expression: "userProfile.state"
                      }
                    ],
                    attrs: { type: "text", required: "" },
                    domProps: { value: _vm.userProfile.state },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.userProfile, "state", $event.target.value)
                      }
                    }
                  })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "uf-row" }, [
              _c("label", [_vm._v("Country:")]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userProfile.country,
                      expression: "userProfile.country"
                    }
                  ],
                  attrs: { type: "text", required: "" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.userProfile,
                        "country",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                _vm._l(_vm.countries, function(country) {
                  return _c("option", [_vm._v(_vm._s(country))])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _vm.advPay && _vm.payMode == null
              ? [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "uf-row pay-method" }, [
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectMode("stripe")
                          }
                        }
                      },
                      [_vm._v("Credit Card")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectMode("paypal")
                          }
                        }
                      },
                      [_vm._v("PayPal")]
                    )
                  ])
                ]
              : _vm.advPay && _vm.payMode == "paypal" && _vm.paymentReady
              ? [
                  _c("div", { staticClass: "uf-row to-c" }, [
                    _c(
                      "button",
                      {
                        staticClass: "main",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.openPaymentUrl($event)
                          }
                        }
                      },
                      [_vm._v("Pay with PayPal")]
                    )
                  ])
                ]
              : _vm.advPay && _vm.payMode == "paypal"
              ? [
                  _c("div", { staticClass: "uf-row" }, [
                    _vm._v("\n          Preparing payment...\n        ")
                  ])
                ]
              : !_vm.advPay || _vm.payMode == "stripe"
              ? [
                  _c("div", { staticClass: "uf-row" }, [
                    _c("label", [_vm._v("Card Number:")]),
                    _vm._v(" "),
                    _c("div", { ref: "payment3", staticClass: "card" })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "uf-row error",
                      domProps: { innerHTML: _vm._s(_vm.cardErrors) }
                    },
                    [_vm._v(_vm._s(_vm.cardErrors))]
                  ),
                  _vm._v(" "),
                  _vm._m(2)
                ]
              : _vm._e()
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.tab == "payment2"
      ? _c("iframe", {
          staticClass: "payframe",
          staticStyle: { height: "900px", width: "100%" },
          attrs: { src: _vm.paymentReady }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("address", [
      _vm._v("\nKathryn Ross-Nash New York Pilates , LLC"),
      _c("br"),
      _vm._v("\n7004 207th St E"),
      _c("br"),
      _vm._v("\nBradenton Fl, 34211, USA\n      ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "uf-row" }, [
      _c("label", [_vm._v("Choose your payment method:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "uf-row to-c" }, [
      _c("button", { staticClass: "main" }, [_vm._v("Pay now")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }